import React, { useContext } from 'react'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function PaymentCards(props) {
  const { paymentCardsImage } = useContext(ConfiguratorContext)

  return (
    <div className='payment-cards'>
      <img src={paymentCardsImage.url} alt={paymentCardsImage.alt}/>
    </div>
  )
}
